import { useCallback, useEffect, useState } from 'react';

/**
 * Light / soft-dark theme.
 *
 * index.html applies the class before first paint to avoid a white flash, so we
 * read the DOM back on mount instead of recomputing the preference - that keeps
 * React's first render consistent with what the user already sees.
 *
 * The storage key must stay in sync with the inline script in index.html.
 */
const STORAGE_KEY = 'z2m-chat-theme';

function readAppliedTheme() {
  if (typeof document === 'undefined') return 'light';
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export function useTheme() {
  const [theme, setTheme] = useState(readAppliedTheme);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* private mode / storage disabled - the class still applies for this session */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, setTheme, toggleTheme, isDark: theme === 'dark' };
}
